import { SaveButton } from "components/Buttons"
import React from "react"
import { connect } from "react-redux"
import { Col, Row } from "reactstrap"

const UserStatusModal = ({
  hideStatusChangeModal,
  loading,
  handleStatusChange,
  isInactive,
}) => {
  return (
    <React.Fragment>
      <Row>
        {isInactive ? (
          <Col>
            <h5>Are you sure you want to do this?</h5>
            <p>
              If the user has a password set, it will be set as Active; if it
              doesn't have a password set, it will be set as Pending.
            </p>
          </Col>
        ) : (
          <Col>
            <h5>Are you sure you want to set this user as inactive?</h5>
            <p>
              The user will be logged out and not be able to use the system
              anymore.
            </p>
            <p>This action can be reverted.</p>
          </Col>
        )}
      </Row>

      <Row className="justify-content-end mt-3">
        <Col xs="auto">
          <SaveButton
            type="button"
            content="Cancel"
            color="danger"
            onClick={hideStatusChangeModal}
          />
        </Col>
        <Col xs="auto">
          <SaveButton
            type="button"
            content={isInactive ? "Revert" : "Set user as inactive"}
            onClick={handleStatusChange}
            loading={loading}
          />
        </Col>
      </Row>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  loading: state.people.setUserBlockStatusIsLoading,
})

export default connect(mapStateToProps)(UserStatusModal)
